<!-- 检测绑定微信登录-弹框组件 -->
<template>
  <a-modal
    v-model="visible"
    title="绑定微信登录"
    :width="600"
    :maskClosable="false"
    :afterClose="afterClose"
  >
    <a-spin :spinning="loading">
      <a-alert message="系统检测到您的手机号码尚未绑定微信登录，扫一扫即可绑定哦~" banner />
      <a-spin tip="拼命获取二维码..." :spinning="!isGetWxLoginCode">
        <div class="wx_code_wrapper">
          <div id="wx_bind_qrcode" class="wx_bind_qrcode"></div>
        </div>
      </a-spin>
      <div class="check_disappeared_box">
        <a-checkbox :checked="isCheckDisappeared" @change="handleChangeCheck">
          {{ disappearedDays }} 天内不再提示
        </a-checkbox>
      </div>
    </a-spin>
    <template #footer>
      <a-button @click="close"> 关 闭 </a-button>
    </template>
  </a-modal>
</template>

<script>
import settings from '@/settings'
import * as loginApi from '@/api/login.api'

export default {
  name: 'checkBindWxModal',
  emits: ['afterClose'],
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      // 是否获取到微信扫码登录的二维码
      isGetWxLoginCode: false,
      // 是否勾选不再提示
      isCheckDisappeared: false,
      // 不再提示的天数
      disappearedDays: '--',
      // 是否成功绑定，用来判断是否调用设置不再提醒
      isSuccessBind: false,
      wxLoginState: null
    }
  },

  methods: {
    handleChangeCheck(e) {
      this.isCheckDisappeared = e.target.checked
    },
    /**
     * 检测是否打开绑定微信登录弹框
     */
    async checkIsOpenCheckBindWxDialog() {
      try {
        const res = await loginApi.needWxBindRemind()
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        if (data) this.open()
      } catch (err) {
        console.error('checkIsOpenCheckBindWxDialog error:', err)
      }
    },

    /**
     * 获取天数
     */
    async getDisappearedDays() {
      try {
        const res = await loginApi.getWxBindNotRemindDays()
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        this.disappearedDays = data || ''
      } catch (err) {
        console.error('getDisappearedDays error:', err)
      }
    },

    /**
     * 设置不再提示
     */
    async setDisappeared() {
      try {
        const res = await loginApi.setupWxBindNotRemind()
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        this.$message.success(`成功设置${disappearedDays.value}天内不再提示`)
      } catch (err) {
        console.error('setDisappeared error:', err)
      }
    },

    /**
     * 微信扫码登录-初始化二维码
     */
    initWxLogin() {
      this.$nextTick(() => {
        this.wxLoginState = Math.ceil(Math.random() * 1000)
        new WxLogin({
          self_redirect: true,
          id: 'wx_bind_qrcode',
          appid: settings.wxScanLoginConfig.appId,
          scope: 'snsapi_login',
          redirect_uri: settings.wxScanLoginConfig.redirectUri,
          state: this.wxLoginState,
          style: 'black',
          // 切换二维码登录样式，值为1时二维码登录将切换到新样式。
          // stylelite: 1,
          href:
            'data:text/css;base64,aWZyYW1le2Rpc3BsYXk6IGJsb2NrO21hcmdpbjogMCBhdXRvOyB3aWR0aDogMjI4cHg7fQouaW1wb3dlckJveCAudGl0bGV7ZGlzcGxheTogbm9uZTt9ICAgICAKLmltcG93ZXJCb3ggLmluZm97d2lkdGg6IDIyOHB4O30gICAgICAKLmltcG93ZXJCb3ggLnFyY29kZSB7CiAgICBkaXNwbGF5OiBibG9jazsKICAgIHdpZHRoOiAxNzhweDsKICAgIG1hcmdpbjogMzFweCBhdXRvIDA7CiAgICBib3JkZXI6IDFweCBzb2xpZCAjZTJlMmUyOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXMgewogICAgcGFkZGluZzogN3B4IDA7Cn0KLmltcG93ZXJCb3ggLnN0YXR1cyBwOm50aC1vZi10eXBlKDIpIHsKICAgIGRpc3BsYXk6IG5vbmU7Cn0=',
          onReady: isReady => {
            this.isGetWxLoginCode = isReady
            console.log('isReady ===', isReady)
          }
        })
      })
    },

    /**
     * 微信扫码登录-接收微信码数据
     */
    wxLoginIframeEvent(event) {
      if (event.origin !== settings.wxScanLoginConfig.redirectOrigin) return
      if (Number(event.data.state) !== this.wxLoginState) return
      console.log('弹窗收到子消息 ====', event)
      if (event.data && event.data.code) this.wxQrCodeBind(event.data.code)
      else this.$message.error('操作失败，请重试~')
    },

    /**
     * 用户扫码绑定微信
     */
    wxQrCodeBind(wxCode) {
      console.log('wxQrCodeBind wxCode ===', wxCode)
      this.loading = true
      loginApi
        .userToBindWxTpAccount({ code: wxCode })
        .then(res => {
          const { code, msg, data } = res.data || {}
          if (code !== 200) {
            this.$message.error(msg)
            // 刷新微信二维码
            this.initWxLogin()
            return
          }
          this.$message.success('绑定成功')
          this.isSuccessBind = true
          this.close()
        })
        .catch(err => {
          console.error('wxQrCodeBind error:', err)
          // 刷新微信二维码
          this.initWxLogin()
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * 重置数据
     */
    afterClose() {
      this.loading = false
      this.isGetWxLoginCode = false
      this.$emit('afterClose')
      // 清除监听事件
      window.removeEventListener('message', this.wxLoginIframeEvent)
      // 如果勾选不再弹窗
      if (this.isCheckDisappeared && !this.isSuccessBind) this.setDisappeared()
    },

    /**
     * 打开弹窗
     */
    open() {
      if (this.visible) return
      this.visible = true
      this.initWxLogin()
      // 父页面接收 iframe 的回复
      window.addEventListener('message', this.wxLoginIframeEvent)
      this.getDisappearedDays()
    },

    /**
     * 关闭弹窗
     */
    close() {
      if (!this.visible) return
      this.visible = false
    }
  },

  mounted() {
    console.log('checkBindWxDialog mounted ================')
    this.checkIsOpenCheckBindWxDialog()
  },

  beforeDestroy() {
    // 清除监听事件
    window.removeEventListener('message', this.wxLoginIframeEvent)
  }
}
</script>

<style lang="scss" scoped>
.wx_code_wrapper {
  height: 262px;
  width: 296px;
  margin: 20px auto 20px;
}

.desc {
  font-size: 16px;
  text-align: center;
  color: #f56c6c;
}

.check_disappeared_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style>
.wx_bind_qrcode iframe {
  height: 262px;
  width: 296px;
  border: none;
  outline: none;
  display: block;
  margin: 0 auto;
}
</style>
